import type { ExtraDetails } from "features/dt-basic-setup/single-building/model/types";

import { Paper, Stack } from "@mui/material";
import { Checkbox } from "components/Checkbox";
import { FormRowLabel } from "components/FormRowLabel";
import { LabelLessInput } from "components/Input";
import React from "react";
import { useTranslation } from "react-i18next";

import type { ModernizationElementKey } from "./types";

import { MODERNIZATION_ELEMENT_KEYS } from "./constants";

export const ModernizationElementsSection = ({
  modernizationElements,
  updateModernizationElement,
}: {
  modernizationElements: ExtraDetails["modernizationElements"];
  updateModernizationElement: (
    key: ModernizationElementKey,
    patch: Partial<{ modernization_date: number; modernized: boolean }>
  ) => void;
}) => {
  const { t } = useTranslation();
  return (
    <Paper className="mt-6 w-full p-4">
      <FormRowLabel label={t("AddBuilding.buildingDetailsStep.modernizationSubheading")} />
      {MODERNIZATION_ELEMENT_KEYS.map((key) => {
        const elem = modernizationElements?.[key] ?? {};
        return (
          <Stack className="mt-2 w-full justify-between" key={key}>
            <Checkbox
              checked={Boolean(elem?.modernized)}
              className=""
              onChange={() =>
                updateModernizationElement(key, {
                  modernization_date: elem?.modernized ? undefined : elem?.modernization_date ?? undefined,
                  modernized: !elem?.modernized,
                })
              }
            >
              <span className="ml-3 font-ds-body-regular-md">
                {t(`AddBuilding.buildingDetailsStep.elements.${key}`)}
              </span>
            </Checkbox>
            <LabelLessInput
              className="w-40"
              disabled={!elem?.modernized}
              height="4rem"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                updateModernizationElement(key, { modernization_date: Number(e.target.value) })
              }
              placeholder={t("AddBuilding.buildingDetailsStep.yearPickerPlaceholder") ?? ""}
              type="number"
              value={elem?.modernization_date}
            />
          </Stack>
        );
      })}
    </Paper>
  );
};
